import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import Home from "./home/Home.js";
import About from "./home/About.js";
import Contact from "./home/Contact.js";
import Job from "./home/Job.js";
import Opinions from "./home/Opinions.js";
import Publications from "./home/Publications.js";

// Helper component to scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/job" element={<Job />} />
                <Route path="/publications" element={<Publications />} />
                <Route path="/opinions" element={<Opinions />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </Router>
    );
}

export default App;
